// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Terapeuti_title__e1YwY {
  font-family: "Inter";
  font-size: 40px;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #4d4d4d;
}
.Terapeuti_searchContainer__XS8qC {
  display: flex;
  width: 85%;
  justify-content: center;
  margin-bottom: 30px;
}
.Terapeuti_text__2tYaB,
.Terapeuti_textSecond__ydCiT {
  font-family: "Inter";
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  letter-spacing: -0.001em;
  text-align: left;
  color: #5f6d7e;
  width: 70%;
}
.Terapeuti_textSecond__ydCiT {
  margin-top: 20px;
}
.Terapeuti_paginationContainer__jgGjk {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 0px;
}
.Terapeuti_h1__Ryrd3 {
  font-family: "Inter";
  font-size: 28px;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.001em;
  text-align: center;
  color: #4d4d4d;
  margin-top: 5%;
  width: 85%;
}
.Terapeuti_cardGrid__sz93R {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  row-gap: 50px;
  column-gap: 5px;
  width: 100%;
}

.Terapeuti_link__lFoX6 {
  text-decoration: none;
  display: contents;
}

@media screen and (max-width: 1150px) {
  .Terapeuti_cardGrid__sz93R {
    grid-template-columns: repeat(3, 1fr);
  }
  .Terapeuti_h1__Ryrd3,
  .Terapeuti_searchContainer__XS8qC {
    width: 100%;
  }
  .Terapeuti_link__lFoX6 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (max-width: 1000px) {
  .Terapeuti_text__2tYaB,
  .Terapeuti_textSecond__ydCiT {
    width: 50%;
  }
}

@media screen and (max-width: 840px) {
  .Terapeuti_cardGrid__sz93R {
    grid-template-columns: repeat(2, 1fr);
    padding-top: 20px;
  }
}

@media screen and (max-width: 775px) {
  .Terapeuti_text__2tYaB,
  .Terapeuti_textSecond__ydCiT {
    width: 60%;
  }
}

@media screen and (max-width: 640px) {
  .Terapeuti_text__2tYaB,
  .Terapeuti_textSecond__ydCiT {
    width: 70%;
  }
}

@media screen and (max-width: 580px) {
  .Terapeuti_cardGrid__sz93R {
    row-gap: 20px;
  }
}

@media screen and (max-width: 460px) {
  .Terapeuti_text__2tYaB,
  .Terapeuti_textSecond__ydCiT {
    width: 85%;
  }
}

@media screen and (max-width: 400px) {
  .Terapeuti_text__2tYaB,
  .Terapeuti_textSecond__ydCiT {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/scenes/terapeuti/Terapeuti.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,UAAU;EACV,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;;IAEE,WAAW;EACb;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,qCAAqC;IACrC,iBAAiB;EACnB;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,WAAW;EACb;AACF","sourcesContent":[".title {\n  font-family: \"Inter\";\n  font-size: 40px;\n  font-weight: 600;\n  line-height: 48px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #4d4d4d;\n}\n.searchContainer {\n  display: flex;\n  width: 85%;\n  justify-content: center;\n  margin-bottom: 30px;\n}\n.text,\n.textSecond {\n  font-family: \"Inter\";\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 22px;\n  letter-spacing: -0.001em;\n  text-align: left;\n  color: #5f6d7e;\n  width: 70%;\n}\n.textSecond {\n  margin-top: 20px;\n}\n.paginationContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 0px;\n}\n.h1 {\n  font-family: \"Inter\";\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 34px;\n  letter-spacing: -0.001em;\n  text-align: center;\n  color: #4d4d4d;\n  margin-top: 5%;\n  width: 85%;\n}\n.cardGrid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  row-gap: 50px;\n  column-gap: 5px;\n  width: 100%;\n}\n\n.link {\n  text-decoration: none;\n  display: contents;\n}\n\n@media screen and (max-width: 1150px) {\n  .cardGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  .h1,\n  .searchContainer {\n    width: 100%;\n  }\n  .link {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n@media screen and (max-width: 1000px) {\n  .text,\n  .textSecond {\n    width: 50%;\n  }\n}\n\n@media screen and (max-width: 840px) {\n  .cardGrid {\n    grid-template-columns: repeat(2, 1fr);\n    padding-top: 20px;\n  }\n}\n\n@media screen and (max-width: 775px) {\n  .text,\n  .textSecond {\n    width: 60%;\n  }\n}\n\n@media screen and (max-width: 640px) {\n  .text,\n  .textSecond {\n    width: 70%;\n  }\n}\n\n@media screen and (max-width: 580px) {\n  .cardGrid {\n    row-gap: 20px;\n  }\n}\n\n@media screen and (max-width: 460px) {\n  .text,\n  .textSecond {\n    width: 85%;\n  }\n}\n\n@media screen and (max-width: 400px) {\n  .text,\n  .textSecond {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `Terapeuti_title__e1YwY`,
	"searchContainer": `Terapeuti_searchContainer__XS8qC`,
	"text": `Terapeuti_text__2tYaB`,
	"textSecond": `Terapeuti_textSecond__ydCiT`,
	"paginationContainer": `Terapeuti_paginationContainer__jgGjk`,
	"h1": `Terapeuti_h1__Ryrd3`,
	"cardGrid": `Terapeuti_cardGrid__sz93R`,
	"link": `Terapeuti_link__lFoX6`
};
export default ___CSS_LOADER_EXPORT___;
